import type { UserManagerSettings } from 'oidc-client-ts';

// A second, independent OIDC config — same app registration as the primary
// login (oidcConfig in config.ts), but pointed at Entra directly instead of
// Cognito, and scoped only to acquire a delegated Graph token for tenant
// people search (ADR 0019). Cognito's own federation never surfaces Entra's
// token to the backend, so this exists purely to get one into the browser.
//
// `authority` differs from the primary config's Cognito `cognito-idp` URL —
// oidc-client-ts keys its user store by `<authority>:<client_id>`, so this
// never collides with or clobbers the primary session's stored user.
const entraIssuerUrl = import.meta.env.VITE_ENTRA_ISSUER_URL as string | undefined;
const entraClientId = import.meta.env.VITE_ENTRA_CLIENT_ID as string | undefined;

export const graphEntraConfigured = Boolean(entraIssuerUrl && entraClientId);

// Deliberately no `offline_access` (no refresh token — ADR 0019) and no
// `automaticSilentRenew` (this flow is invoked on demand, from a picker's
// opt-in, not kept alive for the whole session the way the primary login
// is).
export const graphOidcConfig: UserManagerSettings = {
  authority: entraIssuerUrl ?? '',
  client_id: entraClientId ?? '',
  redirect_uri: `${window.location.origin}/auth/graph-callback`,
  response_type: 'code',
  scope: 'openid profile User.ReadBasic.All',
  loadUserInfo: false,
};
